module.exports = __webpack_public_path__ + "static/img/header-img.6cf12a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/header-img.png
// module id = VApZ
// module chunks = 1